import React, { useState} from 'react'
import Singleselect from '../Singleselect/Singleselectt'
import './Inputfield.css'
// import DesignationJson from './DesignationJson'
// import DepartmentJson from './DepartmentJson'
// import EmployeeJson from './EmployeeJson'
import { AiOutlineMinusCircle, AiOutlinePlusCircle } from 'react-icons/ai'
import Categories from './CategoryJson'
import Desgnselect from '../Singleselect/Desgnselect'
let newJobdescrip = []

const Inputfield = ({DesignJson, EmployeeJson, fieldlabel, DepartmentJson, RegionJson, CountryJson, typeid, placehold, personname, headofunit, unithead, jdarray, RoleJson}) => {
  
    const [changedval, setChangedval] = useState('')
    const [jobdesc, setJobdesc] = useState([{
      jd: ""
    }])

    const handleSelected = (incoming) =>{
      // console.log(incoming)
      unithead(incoming)
    }

    const handleTextChange = (e) =>{
      setChangedval(e.target.value)
      personname(e.target.value)
    }

  const handleAddfield = () =>{
    setJobdesc([...jobdesc, {  jd: "" }])
    // console.log(jobdesc.length)
    newJobdescrip = [...jobdesc];
    jdarray(newJobdescrip)
  }

  const handleRemovefield = (i) =>{
    if(i > 0){
      jobdesc.splice(i, 1 )
      setJobdesc([...jobdesc])
      newJobdescrip = [...jobdesc];
      jdarray(newJobdescrip)
    }
  }

  const handleChange = (i, event) =>{
    newJobdescrip = [...jobdesc];
    newJobdescrip[i][event.target.name] = event.target.value;
    setJobdesc(newJobdescrip);
    jdarray(newJobdescrip)
  }

  const blankFunction = () =>{

  }

  const handleSelectdeptHead = (incoming) =>{
    // console.log(incoming)
    headofunit(incoming)
  }

  return (
    <div className='inputfield-container'>
        <span>{fieldlabel}</span>
        {
          (typeid === "text" || typeid === "email" || typeid === "number" || typeid === "radio" ) ?
          <input 
            id='input-field-container' 
            type={typeid} 
            placeholder={placehold} 
            onChange={handleTextChange} 
            value={changedval}
            required
          /> : 
          typeid === "textarea" ? 
          <textarea 
            id='input-text-area' 
            placeholder={placehold} 
            onChange={handleTextChange} 
            value={changedval}
            required
          />: 
          typeid === "accordion" ? 
          <>
            {jobdesc.map((items, index) => (
              <div key={index} className='input-accord-main-container'>
                <input 
                  id='input-accord-container' 
                  name='jd' 
                  type={typeid} 
                  placeholder={placehold} 
                  onChange={e => handleChange(index, e)} 
                  value={items.jd}
                  required
                />
                <span className='icon-container'>
                  <AiOutlineMinusCircle 
                    id='add-more-field' 
                    onClick={e => handleRemovefield(index)}
                  />
                  <AiOutlinePlusCircle 
                    id='add-more-field' 
                    onClick={handleAddfield}
                  />
                </span>
              </div>
            ))}
          </> : 
          typeid === "descdropdwn" ?  
          <Desgnselect 
            socialjs={DesignJson} 
            desginationSelect={handleSelected} 
            selectedSocVal={handleSelected} 
            placeholder={placehold}
          /> : 
          typeid === "deptheaddropdwn" ? 
          <Singleselect 
            socialjs={DepartmentJson} 
            desginationSelect={handleSelected} 
            selectedSocVal={handleSelectdeptHead} 
            placeholder={placehold}
          /> : 
          <Singleselect 
            socialjs={
                typeid === "regiondropdwn" ? RegionJson : 
                typeid === "countrydropdwn" ? CountryJson : 
                typeid === "deptdropdwn" ? DepartmentJson : 
                typeid === "headsdropdwn" ? EmployeeJson : 
                typeid === "categdropdwn" ? Categories : 
                typeid === "roledropdwn" ? RoleJson : 
                RegionJson
            } 
            desginationSelect={blankFunction} 
            selectedSocVal={handleSelected} 
            placeholder={placehold}
          />
        }
    </div>
  )
}

export default Inputfield